// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3eH6l","col":"styles_col__2HKMY"};